import { render } from "./GenericPasswordChangeForm.html?vue&type=template&id=1b648aa4&ts=true&external"
import script from "./GenericPasswordChangeForm.vue?vue&type=script&lang=ts"
export * from "./GenericPasswordChangeForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__